import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { initialConfig } from '../initialState'
import { handleGetConfiguration, handleGetFTLConfiguration } from './configAction'

const configSlice = createSlice({
  name: 'config',
  initialState: initialConfig,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(handleGetConfiguration.fulfilled, (state, action: PayloadAction<any>) => {
      if (!action.payload) return
      state.data = action.payload.data
    })
    builder.addCase(handleGetFTLConfiguration.fulfilled, (state, action: PayloadAction<any>) => {
      if (!action.payload) return
      state.configFTL = action.payload
    })
  },
})

export default configSlice
